import {
  Button,
  Col,
  DatePicker,
  Form,
  InputNumber,
  Modal,
  Row,
  Upload,
} from 'antd';
import moment from 'moment';
import styled from 'styled-components';
import TextArea from 'antd/lib/input/TextArea';
import { UploadOutlined } from '@ant-design/icons';

import { normFile } from '../../util/utils';

const StyledDiv = styled.div``;

interface IncomeCreateModalProps {
  isOpen: boolean;
  uploadProps: any;
  onCreate: (value: any) => void;
  onClose: () => void;
}

function IncomeCreateModal({
  isOpen,
  uploadProps,
  onCreate,
  onClose,
}: IncomeCreateModalProps) {
  const [form] = Form.useForm();
  return (
    <StyledDiv>
      <Modal
        open={isOpen}
        title="수금정보 입력하기"
        okText="확인"
        cancelText="취소"
        onCancel={() => {
          form.resetFields();
          onClose();
        }}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              onCreate(values);
              form.resetFields();
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <>
          <Row justify="center">
            <Col span={20}>
              <Form
                form={form}
                layout="vertical"
                initialValues={{
                  depositDate: moment(),
                }}
              >
                <Form.Item
                  name="amount"
                  label="수금액(원)"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: '100%' }}
                    formatter={(value) =>
                      `₩ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                    parser={(value) => value!.replace(/₩\s?|(,*)/g, '')}
                  />
                </Form.Item>
                <Form.Item
                  name="depositDate"
                  label="입금일"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
                </Form.Item>
                <Form.Item name="description" label="코멘트">
                  <TextArea rows={4} />
                </Form.Item>
                <Form.Item
                  name="file"
                  label="첨부파일"
                  valuePropName="fileList"
                  getValueFromEvent={normFile}
                >
                  <Upload {...uploadProps}>
                    <Button icon={<UploadOutlined rev={undefined} />}>
                      첨부파일 올리기
                    </Button>
                  </Upload>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default IncomeCreateModal;
